import React from "react";
import styles from "./style.module.css";

const MissionInfo = ({ info, index }) => {
  return (
    <div className={`${styles.singleMission} ${styles.fadeInUp}`}>
      <div className={styles.leftpartContent}>
        <div className={styles.numbers}>
          <h2>{info.No}</h2>
          {index === 2 ? "" : <div className={styles.linePart}></div>}
        </div>
      </div>
      <div className={styles.rightpartContent}>
        <h2>{info.Title}</h2>
        <p>{info.Desc}</p>
      </div>
    </div>
  );
};

export default MissionInfo;
